import React from 'react'
import devilImg from './assets/devil.png'
import devilEyesClosed from './assets/devil-eyes-closed.png'
import './styles.scss'

const Devil = () => {
  return (
    <div className="absolute devil">
      <img src={devilImg} width="100%" className="px-5" />
      <img
        src={devilEyesClosed}
        width="100%"
        className="px-5 absolute devil-eyes-closed"
      />
    </div>
  )
}

export default Devil
